/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";

import { Grid, Card, CardContent } from "@material-ui/core";
import Typography from '@mui/material/Typography';
import Alert from "@material-ui/lab/Alert";
import { TextField, IconButton, LinearProgress, MenuItem } from "@material-ui/core";

import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import DeleteIcon from "@material-ui/icons/Delete";
import ContactMailIcon from "@material-ui/icons/ContactMail";
import { makeStyles } from "@material-ui/core/styles";

import PhotoComponent from "../../components/Photo/PhotoComponent";
import CartRouteComponent from "../../components/Nav/CartRouteComponent";
import ExtraProducts from "./ExtraProducts";
import DiscountBar from "./DiscountBar";
import GeneralButton from "../Buttons";
import GeneralText from "../Fonts";

import MiniCart from "./CartComponents/MiniCart";

import { useMutation } from "@apollo/client";
import {
  GET_SHOPPINGCART,
  ADD_DISCOUNT_CODE,
  UPDATE_CARTPRODUCTS,
  UPDATE_SHOPPINGCART,
  DELETE_DISCOUNT_UPDATE_CART,
  DELETE_CARTPRODUCTS,
  DELETE_ALL_FROM_SHOPPINGCART,
} from "../../queries";
import CartSummary from "./CartSummary";
import { useThemeData } from "../../context/ThemeDataContext";
import { useCartData } from "../../context/CartProvider";
import { useAuthData } from "../../context/AuthProvider";
import ProductPrice from "../ProductPrice";

function CartComponent(props) {
  const { logins } = useAuthData();

  const loginName = localStorage.getItem("login_name");
  const firstPartLogin = loginName !== null ? loginName.replace('["', '') : ''
  const MiddelPartLogin = firstPartLogin.replaceAll('","', ', ')
  const login_name = MiddelPartLogin.replace('"]', '')
  const [login] = useState({login_name});
  const { kassakoopjes } = useThemeData().modules;
  const { site_id } = useThemeData().themeData.site;
  const {
    border_radius,
    font_family,
    primary_color_2,
    background_color_7,
    background_color_2,
    background_color_4,
    cart_header_background,
    cart_header_text
  } = useThemeData().themeData.site.theme;
  const { cartData, networkStatusCart, refetchCart, loadingCart, errorCart } =
    useCartData().cart;

  const useStyles = makeStyles(() => ({
    deleteButton: {
      width: "auto",
      flex: "auto",
    },
    deleteButtonIcon: {
      color: `${background_color_2}`,
      borderRadius: `${border_radius}`,
      "&:active": {
        boxShadow: `0px 0px 16px 4px ${background_color_4}`,
      },
      "&:hover": {
        boxShadow: `0px 0px 12px 4px ${background_color_4}`,
      },
    },
  }));
  const classes = useStyles();

  const [Messages, setMessages] = useState({
    updateMessage: false,
    deleteMessage: false,
    discountCodeMessage: false,
    discountCodeRemoved: false,
    discountCodeFailedMessage: false,
    discountCodeExistMessage: false,
    discountCodeUsedMessage: false,
    discountCodePriceMessage: false,
  });

  const handleSetMessages = (message) => {
    setMessages({message});
  }

  const [session_id] = useState(localStorage.getItem("session_id"));
  // const [container, setContainer] = useState("noContainer margin-around");
  const [linkClass] = useState({
    package: { id: "", product: "" },
    subproduct: { id: "", product: "" },
    single: { id: "", product: "" },
  });
  // const [loadingId, setLoadingId] = useState();
  const cartUpdated = props.cartUpdated;
  const setCartUpdated = props.setCartUpdated;
  const [dataCart, setDataCart] = useState(undefined);

  const shippingMethod = localStorage.hasOwnProperty("shippingMethod")
      ? localStorage.getItem("shippingMethod")
      : '';

  useEffect(() => {
    if (cartUpdated === true) {
      // console.log('hier dan123?')
      // refetchCart();
      setCartUpdated(false);
    }
  }, [cartUpdated, setCartUpdated]);

  useEffect(() => {
    if (
      Messages.discountCodeMessage === true ||
      Messages.discountCodeRemoved === true
    ) {
      refetchCart();
    }
  }, [Messages.discountCodeMessage, Messages.discountCodeRemoved, refetchCart]);

  useEffect(() => {
    if (cartData !== undefined) {
      // console.log('country mama')
      setDataCart(cartData);
    }
  }, [cartData]);

  const onSuccess = () => {
    // console.log('on success')
    const location = {
      pathname: "/addressform",
      state: { login_name: logins, site_id: site_id, user_id: props.user_id },
    };
    props.history.push(location);
  };

  const onDeleted = () => {
    setMessages({
      deleteMessage: true,
      updateMessage: false,
      discountCodeMessage: false,
      discountCodeRemoved: false,
      discountCodeFailedMessage: false,
      discountCodeExistMessage: false,
      discountCodeUsedMessage: false,
      discountCodePriceMessage: false,
    });
  };

  const onUpdated = () => {
    setMessages({
      updateMessage: true,
      deleteMessage: false,
      discountCodeMessage: false,
      discountCodeRemoved: false,
      discountCodeFailedMessage: false,
      discountCodeExistMessage: false,
      discountCodeUsedMessage: false,
      discountCodePriceMessage: false,
    });
  };

  const [
    deleteDiscountCodes,
    { loading: loadingDeleteDiscount, error: errorDeleteDiscount },
  ] = useMutation(DELETE_DISCOUNT_UPDATE_CART, {
    onCompleted: (data) => {
      // refetchCart();
    },
  });

  const [
    deleteCartProducts,
    { loading: loadingDeleteCartProducts, error: errorDeleteCartProducts },
  ] = useMutation(DELETE_CARTPRODUCTS, {
    onCompleted: onDeleted,
    notifyOnNetworkStatusChange: true,
    refetchQueries: [
      {
        query: GET_SHOPPINGCART,
        variables: {
          session_id: session_id,
          site_id: site_id,
          login_name: [logins],
          shipping_method: shippingMethod
        },
      },
    ],
  });

  const [
    updateShoppingcart,
    { loading: loadingUpdateShoppingCart, error: errorUpdateShoppingCart },
  ] = useMutation(UPDATE_SHOPPINGCART, {
    onCompleted: onSuccess,
  });

  const [
    updateCartProducts,
    {
      loading: loadingUpdateCart,
      // error: errorUpdateCart
    },
  ] = useMutation(UPDATE_CARTPRODUCTS, {
    onCompleted: onUpdated,
    notifyOnNetworkStatusChange: true,
    refetchQueries: [
      {
        query: GET_SHOPPINGCART,
        variables: {
          session_id: session_id,
          site_id: site_id,
          login_name: [logins],
          shipping_method: shippingMethod
        },
      }
    ],
  });

  const [
    deleteShoppingcart,
    { loading: loadingDeleteCart, error: errorDeleteCart },
  ] = useMutation(DELETE_ALL_FROM_SHOPPINGCART, {
    onCompleted: onDeleted,
  });

  const [submitDiscount, { loading: loadingDiscountCodeCart }] = useMutation(
    ADD_DISCOUNT_CODE,
    {
      onCompleted: (event) => {
        setMessages({
          discountCodeMessage: true,
          updateMessage: false,
          deleteMessage: false,
          discountCodeRemoved: false,
          discountCodeFailedMessage: false,
          discountCodeExistMessage: false,
          discountCodePriceMessage: false,
          discountCodeUsedMessage: false,
        });
      },
      onError: (err) => {
        switch (err.message) {
          case "al gebruikt":
            setMessages({
              discountCodeUsedMessage: true,
              updateMessage: false,
              deleteMessage: false,
              discountCodeMessage: false,
              discountCodeRemoved: false,
              discountCodeExistMessage: false,
              discountCodePriceMessage: false,
              discountCodeFailedMessage: false,
            });
            break;
          case "al actief.":
            setMessages({
              discountCodeExistMessage: true,
              updateMessage: false,
              deleteMessage: false,
              discountCodeMessage: false,
              discountCodeRemoved: false,
              discountCodeFailedMessage: false,
              discountCodePriceMessage: false,
              discountCodeUsedMessage: false,
            });
            break;
          default:
            setMessages({
              discountCodeFailedMessage: true,
              updateMessage: false,
              deleteMessage: false,
              discountCodeMessage: false,
              discountCodeRemoved: false,
              discountCodeExistMessage: false,
              discountCodePriceMessage: false,
              discountCodeUsedMessage: false,
            });
            break;
        }
      },
    }
  );

  // const onNavigateHome = () => {
  //   window.location.replace(`/`);
  // };

  const goToProduct = (product_id, photo_id, filename, folder_id) => {
    const location = {
      pathname: `/shoppage/photo_id/${photo_id}`,
      state: {
        state: {
          photo_id: photo_id,
          folder_id: folder_id,
          photo_file_name: filename,
          product_id: product_id,
        },
      },
    };
    props.history.push(location);
  };

  const handleDiscountDeletion = (e, cartid) => {
    e.preventDefault();
    if (!loadingDeleteDiscount && !errorDeleteDiscount) {
      setMessages({
        discountCodeRemoved: true,
        updateMessage: false,
        deleteMessage: false,
        discountCodeMessage: false,
        discountCodeFailedMessage: false,
        discountCodeExistMessage: false,
      });
      deleteDiscountCodes({
        variables: {
          id: cartid,
          session_id: session_id,
          discount_code: null,
        },
      });
    }
  };

  const handleDiscount = (e, data, discount_code) => {
    e.preventDefault();

    if (!loadingDiscountCodeCart) {
      submitDiscount({
        variables: {
          site_id: site_id,
          session_id: session_id,
          discount_code: discount_code,
          price: data.shoppingcart.subtotaal,
        },
      });
    }
  };

  const handleUpdateShoppingcart = (e, data) => {
    e.preventDefault();
    // console.log('hoi !')
    if (!loadingUpdateShoppingCart && !errorUpdateShoppingCart) {
      updateShoppingcart({
        variables: {
          id: data.shoppingcart.id,
          session_id: session_id,
          tax: data.shoppingcart.tax,
          discount: data.shoppingcart.discount,
          subtotaal: data.shoppingcart.subtotaal,
          totaal: data.shoppingcart.totaal,
          shippingcost_type: data.shoppingcart.shippingcost_type,
          shippingcost_type_name: data.shoppingcart.shippingcost_type_name,
        },
        // fetchPolicy: "no-cache",
      });
    }
  };

    // function that converts string with comma to number with decimal
    function convertToNumber(value) {
      return +parseFloat(value.replace(",", ".")).toFixed(2);
    }
    function convertToComma(value) {
      return parseFloat(value).toFixed(2).toString().replace(".", ",");
    }

  function renderProductVariation(variationString) {
    if (!variationString) return null;

    // Parse the JSON string into an object
    const variationObject = JSON.parse(variationString);

    // Generate list items
    const listItems = Object.entries(variationObject).map(([key, value]) => {
      // Check if value is an object (for nested properties)
      if (typeof value === 'object' && value !== null) {
        const nestedItems = Object.entries(value).map(([nestedKey, nestedValue], index, array) => (
            <React.Fragment key={nestedKey}>
              <span>{nestedKey}: {nestedValue}</span>
              {index < array.length - 1 && <br />}
            </React.Fragment>
        ));
        return (
            <li key={key} style={{ margin: 0, fontWeight: "normal" }}>
              {key}: {nestedItems}
            </li>
        );
      } else {
        // Direct string value
        return (
            <li key={key} style={{ margin: 0, fontWeight: "normal"  }}>
              {key}: {value}
            </li>
        );
      }
    });

    // Prepend the heading 'Jouw opties' as the first list item
    listItems.unshift(
        <li key="heading" style={{ margin: 0 }}>Jouw opties:</li>
    );

    return (
        <ul style={{ listStyle: 'none', margin: 0, padding:0 }}>
          {listItems}
        </ul>
    );
  }

  async function UpdateProductAmount(e, product) {
    e.preventDefault();
    const value = e.target.value;
    if (value === 0) {
      HandleDeleteCartProducts(e, product.id);
    } else {
      if (!loadingUpdateCart) {
          // setLoadingId(product.id);
            updateCartProducts({
              variables: {
                id: product.id,
                amount: value,
                login_name: login,
                site_id: site_id,
                session_id: session_id
              },
              optimisticResponse: {
                __typename: "Mutation",
                updateCartProducts: {
                  __typename: "CartProducts",
                  id: product.id,
                  amount: e.target.value,
                  login_name: login,
                  site_id: site_id,
                  session_id: session_id
                },
              },
              update: (cache, { data }) => {
                const  { shoppingcart } = cache.readQuery({
                  query: GET_SHOPPINGCART,
                  variables: {
                    session_id: session_id,
                    site_id: site_id,
                    login_name: [logins],
                    shipping_method: shippingMethod
                  },
                });

                let subtotalPrice = 0.00;

                shoppingcart.cartproducts.forEach(product => {
                  // console.log(convertToNumber(product.org_totaal_prijs))
                  subtotalPrice += convertToNumber(product.org_stuks_prijs) * convertToNumber(product.amount);
                });

                const totalPrice = subtotalPrice + convertToNumber(shoppingcart.shippingcost) + convertToNumber(shoppingcart.administrationcosts);

                // console.log(totalPrice * 21 / 121)

                cache.writeQuery({
                  query: GET_SHOPPINGCART,
                  variables: {
                    session_id: session_id,
                    site_id: site_id,
                    login_name: [logins],
                    shipping_method: shippingMethod
                  },
                  data: {
                    shoppingcart: {
                      __typename: "Shoppingcart",
                      id: shoppingcart.id,
                      subtotaal: convertToComma(subtotalPrice),
                      totaal: totalPrice,
                      tax: convertToComma(totalPrice * 21 / 121),

                      shippingcost: shoppingcart.shippingcost,
                      administrationcosts: shoppingcart.administrationcosts,
                    },
                  },
                });
              },
        });
      }
    }
  }


  async function HandleDeleteCartProducts(e, id) {
    e.preventDefault();
    // console.log('take me home')
    if (!loadingDeleteCartProducts) {
          deleteCartProducts({
            variables: {
              id: id,
            },
            optimisticResponse: {
              __typename: "Mutation",
              deleteCartProducts: {
                __typename: "CartProducts",
                id: id,
              },
            },
            update: (cache, { data: { deleteCartProducts } }) => {
              const { shoppingcart } = cache.readQuery({
                query: GET_SHOPPINGCART,
                variables: {
                  session_id: session_id,
                  site_id: site_id,
                  login_name: [logins],
                  shipping_method: shippingMethod
                },
              });
              cache.writeQuery({
                query: GET_SHOPPINGCART,
                variables: {
                  session_id: session_id,
                  site_id: site_id,
                  login_name: [logins],
                  shipping_method: shippingMethod
                },
                data: {
                  shoppingcart: {
                    __typename: "Shoppingcart",
                    id: shoppingcart.id,
                    cartproducts: shoppingcart.cartproducts.filter(
                      (cartproducts) => {
                       return cartproducts.id !== id
                      }
                    ),
                  },
                },
              });
            },
          })
    }
  }

  const handleDeleteShoppingCart = (e) => {
    e.preventDefault();
    // console.log('to a place')
    if (!loadingDeleteCart && !errorDeleteCart) {
      deleteShoppingcart({
        variables: {
          session_id: session_id,
        },
        optimisticResponse: {
          __typename: "Mutation",
          deleteShoppingcart: {
            __typename: "Shoppingcart",
            id: session_id
          },
        }
      });
      // refetchCart();
    }
  };


  if (networkStatusCart === 4)
    return <p>{props.t("shoppingcart:Refreshing your shoppingcart")}</p>;
  if (loadingCart)
    return (
      <LinearProgress
        className="align-self-center"
        style={{ color: primary_color_2 }}
      />
    );
  if (
    dataCart === undefined ||
    errorCart ||
    errorDeleteCartProducts ||
    errorDeleteCart ||
    errorUpdateShoppingCart
  )
    return <p>{props.t("Looks like we have a problem...")}</p>;
  return (
    // no cart data available
    dataCart !== undefined ? (
      dataCart.shoppingcart.status === "error" ? (
        <div className="top-margin mb-2">
          <p
            style={{
              fontFamily: `${font_family}`,
              color: `${primary_color_2}`,
              margin: `0.5rem`,
            }}
          >
            {props.t("shoppingcart:cart is empty")}
          </p>
          <Link to={`/`}>
            <GeneralButton
              className="btn btn-light btn-margin"
              type="link"
              endIcon={<ShoppingCartIcon color="inherit" />}
            >
              {props.t("shoppingcart:Continue Shopping")}
            </GeneralButton>
          </Link>
        </div>
      ) : props.cart ? (
        // minicart in navbar and cart in addressform
          <div className="cartAdressForm">
         <MiniCart
            {...props}
            addressform="false"
            dataCart={dataCart}
            setMessages={handleSetMessages}
          />
          </div>
      ) : // shoppingcart
      props.shoppingcart ? (
        <Grid
          container
          direction="row"
          style={{
            fontFamily: `${font_family}`,
            color: `${primary_color_2}`,
          }}
          className="container-margin"
        >
          <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
            <GeneralText
              className="text-center"
              variant="h1"
              gutterBottom={true}
            >
              {props.t("shoppingcart:cart")}
            </GeneralText>
          </Grid>
          {props.type !== "homePrintService" ? (
            <Grid
              container
              direction="row"
              className="text-center"
              style={{ justifyContent: "center" }}
            >
              <Grid item lg={6} md={6} xs={12}>
                <CartRouteComponent activeStep={"1"} />
              </Grid>
            </Grid>
          ) : null}

          <Grid item lg={2} md={6} sm={6} xs={12} className="cart-button-af">
            <Grid container direction="row" className="cart-button-row" id="buttom-pay" style={{
              marginBottom: "1rem", marginTop: "20px"
            }}>
              <GeneralButton
                  onClick={(e) => handleUpdateShoppingcart(e, dataCart)}
                  style={{
                    marginRight: "0px",
                  }}
                  className="btn btn-light cart-button-width"
                  type="submit"
                  endIcon={<ContactMailIcon color="inherit" />}
              >
                {props.t("shoppingcart:Proceed to address form")}
              </GeneralButton>
            </Grid>
          </Grid>
          <Grid container direction="row" className="page-edge">
            <Grid item lg={12} md={12} xs={12}>
              <Card className="">
                <div
                    className="cartHeader"
                  style={{
                    backgroundColor: `${cart_header_background}`,
                    borderColor: `${background_color_4}`,
                    color: `${cart_header_text}`
                  }}
                >
                  <Grid container direction="row" spacing={3}>
                    <Grid item xs={12} sm={2} md={2}>
                      <Typography className="title"  variant="h6" align={"left"}>
                        {props.t("shoppingcart:Photo")}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={2} md={2}>
                      <Typography variant="h6" align={"left"}>
                        {props.t("shoppingcart:Product")}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={2} md={1}>
                      <Typography variant="h6" align={"left"}>
                        {props.t("shoppingcart:Effect")}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={2} md={1}>
                      <Typography variant="h6" align={"left"} className="text-left">
                        {props.t("shoppingcart:Price")}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={2} md={2}>
                      <Typography variant="h6" className="pl-1 pr-1 ">
                        {props.t("shoppingcart:Quantity")}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={2} md={2}>
                      <Typography variant="h6" className="no-padding-right">
                        {props.t("shoppingcart:Total Price")}
                      </Typography>
                    </Grid>
                  </Grid>
                </div>
                {Messages.deleteMessage && (
                  <Alert severity="info" >
                    {props.t(
                      "shoppingcart:Your product has been deleted from the shoppingcart"
                    )}
                  </Alert>
                )}
                {Messages.updateMessage && (
                  <Alert severity="warning">
                    {props.t("shoppingcart:Your product has been updated")}
                  </Alert>
                )}
                {dataCart.shoppingcart.discount_message && (
                  <Alert severity="warning">
                {dataCart.shoppingcart.discount_message}
                  </Alert>
                )}
                {dataCart.shoppingcart.cartproducts.map((cartproduct) => (
                  <CardContent
                    key={cartproduct.id}
                    className="cartItems border-bottom-small"
                    style={{ borderColor: `${background_color_4}` }}
                  >
                    <Grid
                      container
                      direction="row"
                      className="mt-2"
                      spacing={3}
                    >
                      {cartproduct.products.product_type !== "pakket" ? (
                        <>
                          <Grid item xs={12}>
                            {(() => {

                              if (
                                  cartproduct.korting_pakketten_aantal !== null &&
                                  cartproduct.korting_pakketten_perc !== null
                              ) {
                                return (
                                    <Alert
                                        severity="warning"
                                        className="card-footer full-width-margin"
                                    >
                                      {cartproduct.korting_pakketten_aantal !== null
                                          ? `${props.t(
                                              "shoppage:With a quantity of "
                                          )}${
                                              cartproduct.korting_pakketten_aantal
                                          } ${props.t(
                                              "shoppage:Or more of this package you will receive "
                                          )}`
                                          : null}
                                      {cartproduct.korting_pakketten_perc !== null
                                          ? `${
                                              cartproduct.korting_pakketten_perc
                                          }% ${props.t("shoppage:Discount")}`
                                          : null}
                                    </Alert>
                                );
                              }
                              if (
                                  cartproduct.quantum_aantal !== null &&
                                  cartproduct.quantum_perc !== null
                              ) {
                                return (
                                    <Alert
                                        severity="warning"
                                        className="card-footer full-width-margin"
                                    >
                                      {cartproduct.quantum_aantal !== null
                                          ? `${props.t(
                                              "shoppage:With a quantity of "
                                          )}${cartproduct.quantum_aantal} ${props.t(
                                              "shoppage:Or more of this product you will receive "
                                          )}`
                                          : null}
                                      {cartproduct.quantum_perc !== null
                                          ? `${cartproduct.quantum_perc}% ${props.t(
                                              "shoppage:Discount"
                                          )}`
                                          : null}
                                    </Alert>
                                );
                              }
                            })()}
                          </Grid>
                          <Grid item xs={6} sm={8} md={2}>
                            {cartproduct.product_type !== 'divers' && (
                            <Typography className="row hide-overflow" align={"left"}>
                              {cartproduct.photo_info.file_name}
                            </Typography>
                            )}
                            {cartproduct.effect_file_name_for}
                            <PhotoComponent
                              photo_id={cartproduct.photo_info.id}
                              photo_file_name={
                                cartproduct.products.product_file
                              }
                              product_id={cartproduct.products.product_id}
                              product_image={cartproduct.products.product_image}
                              product_type={cartproduct.products.product_type}
                              folder_id={cartproduct.photo_info.folder_id}
                              combivel_id={cartproduct.combivel_id}
                              product_color={cartproduct.image_effect}
                              effect_file_name={cartproduct.effect_file_name}
                              effect_file_id={cartproduct.effect_file_id}
                              effect_file_name_for={cartproduct.effect_file_name_for}
                              effect_file_id_for={cartproduct.effect_file_id_for}
                              photoType={1}
                            />
                          </Grid>
                          <Grid item xs={6} sm={6} md={2}>
                            <Typography
                                align={"left"}
                              className={`font-bold ${
                                linkClass.single.id ===
                                cartproduct.products.product_id
                                  ? linkClass.single.product
                                  : ""
                              }`}
                              // onClick={() =>
                              //   goToProduct(
                              //     cartproduct.products.product_id,
                              //     cartproduct.photo_info.id,
                              //     cartproduct.photo_info.file_name,
                              //     cartproduct.photo_info.folder_id
                              //   )
                              // }
                            >
                              {cartproduct.products.product_type}{" "}
                              {cartproduct.products.product_name}
                              {renderProductVariation(cartproduct.product_variation)}
                            </Typography>
                          </Grid>
                        </>
                      ) : (
                        // pakket
                        <>
                          <Grid item xs={12} sm={12} md={4}>
                            <Grid container direction="row">
                              {cartproduct.subproducten.map(
                                (productensub, index) => (
                                  <>
                                    <Grid container direction="row" spacing={2} key={index}>
                                      <Grid item sm={12} xs={6} md={6}>
                                        {productensub.product_id != null && (
                                          <p
                                            key={productensub.product_id}
                                            className="text-h"
                                          >
                                            {productensub.product_id}
                                          </p>
                                        )}
                                        <PhotoComponent
                                          photo_id={productensub.photo_info.id}
                                          product_id={productensub.products.product_id}
                                          photo_file_name={productensub.products.product_file}
                                          product_image={productensub.products.product_image}
                                          product_type={productensub.products.product_type}
                                          combivel_id={productensub.combivel_id}
                                          effect_file_name={cartproduct.effect_file_name}
                                          effect_file_id={cartproduct.effect_file_id}
                                          effect_file_name_for={cartproduct.effect_file_name_for}
                                          effect_file_id_for={cartproduct.effect_file_id_for}
                                          folder_id={productensub.photo_info.folder_id}
                                          product_color={productensub.image_effect}
                                          photoType={1}
                                        />
                                      </Grid>
                                      {/* <Hidden smDown> */}
                                        <Grid item xs={6} sm={6} md={6}>
                                          {index === 0 && (
                                            <div className="list-wrapper">
                                              <p
                                                className={`font-bold ${
                                                  linkClass.package.id ===
                                                  cartproduct.products.product_id
                                                    ? linkClass.package.product
                                                    : ""
                                                }`}
                                                // onClick={() =>
                                                //   goToProduct(
                                                //     cartproduct.products.product_id,
                                                //     cartproduct.photo_info.id,
                                                //     cartproduct.photo_info.file_name,
                                                //     cartproduct.photo_info.folder_id
                                                //   )
                                                // }
                                              >
                                                {cartproduct.products.product_type}{" "}
                                                {cartproduct.products.product_name}
                                              </p>
                                            </div>
                                          )}

                                          {index >= 0 && (
                                            <>
                                              <div
                                                key={productensub.product_id}
                                                className=" margin-bttm"
                                              >
                                                <p
                                                  className={`no-margin-bttm font-bold ${
                                                    linkClass.subproduct.id ===
                                                    index + "a"
                                                      ? linkClass.subproduct.product
                                                      : ""
                                                  }`}
                                                  onClick={() =>
                                                    goToProduct(
                                                      productensub.products.product_id,
                                                      productensub.photo_info.id,
                                                      productensub.photo_info.file_name,
                                                      productensub.photo_info.folder_id
                                                    )
                                                  }
                                                >
                                                  {props.t("shoppingcart:Chosen at")}{" "}
                                                  {productensub.products.product_name}{" "}
                                                  {productensub.products.formaat}
                                                  :
                                                </p>
                                                {productensub.products.product_type !== 'divers' && (
                                                <p>
                                                  {productensub.products.product_file_name}
                                                </p>
                                                )
                                                }
                                              </div>
                                            </>
                                          )}
                                        </Grid>
                                      {/* </Hidden> */}
                                    </Grid>
                                  </>
                                )
                              )}
                              {/* </div> */}
                            </Grid>
                          </Grid>
                        </>
                      )}
                      <Grid
                        item
                        xs={6}
                        sm={6}
                        md={4}
                        lg={1}
                        className="custom-d-md-none"
                      >
                        <Typography
                          style={{
                            backgroundColor: `${background_color_7}`,
                            borderColor: `${background_color_4}`,
                          }}
                        >
                          {props.t("shoppingcart:Effect")}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} sm={6} md={1}>
                        <Typography align={'left'}>
                          {cartproduct.image_effect}
                          {cartproduct.effect_file_name && cartproduct.effect_file_name.trim() !== '' ? ` | ${cartproduct.effect_file_name}` : ''}
                          {cartproduct.effect_file_name_for && cartproduct.effect_file_name_for.trim() !== '' ? ` | ${cartproduct.effect_file_name_for}` : ''}
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        sm={6}
                        lg={1}
                        className="custom-d-md-none"
                      >
                        <Typography align={'left'}
                          style={{
                            backgroundColor: `${background_color_7}`,
                            borderColor: `${background_color_4}`,
                          }}
                        >
                          {props.t("shoppingcart:Price")}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} sm={6} md={1}>
                        <ProductPrice price={cartproduct.org_stuks_prijs} actionprice={cartproduct.stuks_price} from={true}></ProductPrice>
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        sm={6}
                        className="custom-d-md-none"
                      >
                        <Typography
                          style={{
                            backgroundColor: `${background_color_7}`,
                            borderColor: `${background_color_4}`,
                          }}
                        >
                          {props.t("shoppingcart:Quantity")}
                        </Typography>
                      </Grid>
                      {cartproduct.subproducten.every(
                          (productensub) =>
                              productensub.products.product_type === "download" ||
                              productensub.products.product_type === "groepsfoto download"
                      ) ? (<Grid item xs={6} sm={4} md={2}></Grid>) : (
                          <Grid item xs={6} sm={4} md={2}>
                            {cartproduct.products.product_type !== "download" &&
                            props.product_type !== "groepsfoto download" ? (
                                <TextField
                                    id={cartproduct.id}
                                    select
                                    value={cartproduct.amount}
                                    label={props.t("shoppingcart:Quantity")}
                                    onChange={(e) => UpdateProductAmount(e, cartproduct)}
                                    variant="outlined"
                                    fullWidth
                                >
                                  {[...Array(10)].map((value, index) => {
                                    return (
                                        <MenuItem id={index + 1} key={index} value={index}>
                                          {index}
                                        </MenuItem>
                                    );
                                  })}
                                </TextField>
                            ) : (
                                <></>
                            )}
                          </Grid>
                      )}
                      <Grid
                        item
                        xs={6}
                        sm={6}
                        lg={1}
                        className="custom-d-md-none"
                      >
                        <Typography
                          style={{
                            backgroundColor: `${background_color_7}`,
                            borderColor: `${background_color_4}`,
                          }}
                        >
                          {props.t("shoppingcart:Total Price")}
                        </Typography>
                      </Grid>
                        <Grid item xs={6} sm={6} md={2}>
                          <ProductPrice price={cartproduct.org_totaal_prijs} actionprice={cartproduct.total_price} from={true}></ProductPrice>
                        </Grid>
                      <Grid item xs={12} sm={6} md={1}>
                        <IconButton
                          variant="link"
                          key={cartproduct.id}
                          className={`${classes.deleteButton} btn-color-dark btn col-lg-1 align-bottom-auto align-items-flex-start no-bttn-style deleteButton`}
                          onClick={(e) =>
                            HandleDeleteCartProducts(e, cartproduct.id)
                          }
                        >
                          <DeleteIcon
                            color="inherit"
                            className={`${classes.deleteButtonIcon}`}
                          />
                        </IconButton>
                      </Grid>
                    </Grid>
                  </CardContent>
                ))}
              </Card>
            </Grid>
          </Grid>
          {kassakoopjes && (
            <Grid
              item
              xs={12}
              md={12}
              lg={12}
              xl={12}
              className="extra-products"
              style={{ marginTop: "1rem", marginBottom: "1rem" }}
            >
              <Grid container direction="row">
                <ExtraProducts {...props} kassakoopjes={kassakoopjes} />
              </Grid>
            </Grid>
          )}

          <Grid
            container
            direction="row"
            id="discountbar_cart-summary"
            className="discountbar cart-summary page-edge"
          >
            <DiscountBar
              {...props}
              dataCart={dataCart}
              name="discount_code"
              Messages={Messages}
              handleDiscount={handleDiscount}
            />
            <Grid item lg={4}>

            </Grid>
            <CartSummary
              {...props}
              dataCart={dataCart}
              handleDiscountDeletion={handleDiscountDeletion}
            />
          </Grid>

          <Grid
            container
            direction="row"
            id="cart_buttons"
            className={`cart-buttons`}
            spacing={1}
          >
            <Grid item lg={2} md={6} sm={6} xs={12} className="cart-button">
              <Grid container direction="row" className="cart-button-row">
                <GeneralButton
                  key={session_id}
                  className="delete btn cart-button-width"
                  type="link"
                  onClick={(e) => handleDeleteShoppingCart(e)}
                  endIcon={<DeleteIcon color="error" />}
                >
                  {props.t("shoppingcart:Empty shoppingCart")}
                </GeneralButton>
              </Grid>
            </Grid>
            <Grid item lg={2} md={6} sm={6} xs={12} className="cart-button">
              <Grid container direction="row" className="cart-button-row">
                <GeneralButton
                    component={Link}
                    to={`/`}
                    name="overview"
                    className="btn btn-light cart-button-width"
                    type="link"
                    endIcon={<ShoppingCartIcon color="inherit" />}
                >
                  {props.t("shoppingcart:Continue Shopping")}
                </GeneralButton>
              </Grid>
            </Grid>
            <Grid item lg={2} md={6} sm={6} xs={12} className="">
              <Grid container direction="row" className="cart-button-row" id="buttom-pay" style={{
                marginBottom: "200px",
              }}>
                <GeneralButton
                  onClick={(e) => handleUpdateShoppingcart(e, dataCart)}
                  style={{
                    marginRight: "0px",
                  }}
                  className="btn btn-light cart-button-width"
                  type="submit"
                  endIcon={<ContactMailIcon color="inherit" />}
                >
                  {props.t("shoppingcart:Proceed to address form")}
                </GeneralButton>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      ) : null
    ) : null
  );
}

export default React.memo(
  withTranslation(["message", "shoppingcart", "shoppage"])(CartComponent)
);
